// Funciones
import { ROUTES } from "../../../../../const/routes";

/**
 * Assets de los ultimos numeros de la ruleta
 * @param {*} scene 
 */
export function cargaAssetsUltimosNumeros(scene) {

  scene.load.image(
    "ultimoNumero0",
    ROUTES.rutaRuletaUltimosNumeros + "/ultimoNumero0Resized.png"
  );
  scene.load.image(
    "ultimoNumero1",
    ROUTES.rutaRuletaUltimosNumeros + "/ultimoNumero1Resized.png"
  );
  scene.load.image(
    "ultimoNumero2",
    ROUTES.rutaRuletaUltimosNumeros + "/ultimoNumero2Resized.png"
  );
  scene.load.image(
    "ultimoNumero3",
    ROUTES.rutaRuletaUltimosNumeros + "/ultimoNumero3Resized.png"
  );
  scene.load.image(
    "ultimoNumero4",
    ROUTES.rutaRuletaUltimosNumeros + "/ultimoNumero4Resized.png"
  );
  scene.load.image(
    "ultimoNumero5",
    ROUTES.rutaRuletaUltimosNumeros + "/ultimoNumero5Resized.png"
  );
  scene.load.image(
    "ultimoNumero6",
    ROUTES.rutaRuletaUltimosNumeros + "/ultimoNumero6Resized.png"
  );
  scene.load.image(
    "ultimoNumero7",
    ROUTES.rutaRuletaUltimosNumeros + "/ultimoNumero7Resized.png"
  );
  scene.load.image(
    "ultimoNumero8",
    ROUTES.rutaRuletaUltimosNumeros + "/ultimoNumero8Resized.png"
  );
  scene.load.image(
    "ultimoNumero9",
    ROUTES.rutaRuletaUltimosNumeros + "/ultimoNumero9Resized.png"
  );
  scene.load.image(
    "ultimoNumero10",
    ROUTES.rutaRuletaUltimosNumeros + "/ultimoNumero10Resized.png"
  );
  scene.load.image(
    "ultimoNumero11",
    ROUTES.rutaRuletaUltimosNumeros + "/ultimoNumero11Resized.png"
  );
  scene.load.image(
    "ultimoNumero12",
    ROUTES.rutaRuletaUltimosNumeros + "/ultimoNumero12Resized.png"
  );
  scene.load.image(
    "ultimoNumero13",
    ROUTES.rutaRuletaUltimosNumeros + "/ultimoNumero13Resized.png"
  );
  scene.load.image(
    "ultimoNumero14",
    ROUTES.rutaRuletaUltimosNumeros + "/ultimoNumero14Resized.png"
  );
  scene.load.image(
    "ultimoNumero15",
    ROUTES.rutaRuletaUltimosNumeros + "/ultimoNumero15Resized.png"
  );
  scene.load.image(
    "ultimoNumero16",
    ROUTES.rutaRuletaUltimosNumeros + "/ultimoNumero16Resized.png"
  );
  scene.load.image(
    "ultimoNumero17",
    ROUTES.rutaRuletaUltimosNumeros + "/ultimoNumero17Resized.png"
  );
  scene.load.image(
    "ultimoNumero18",
    ROUTES.rutaRuletaUltimosNumeros + "/ultimoNumero18Resized.png"
  );
  scene.load.image(
    "ultimoNumero19",
    ROUTES.rutaRuletaUltimosNumeros + "/ultimoNumero19Resized.png"
  );
  scene.load.image(
    "ultimoNumero20",
    ROUTES.rutaRuletaUltimosNumeros + "/ultimoNumero20Resized.png"
  );
  scene.load.image(
    "ultimoNumero21",
    ROUTES.rutaRuletaUltimosNumeros + "/ultimoNumero21Resized.png"
  );
  scene.load.image(
    "ultimoNumero22",
    ROUTES.rutaRuletaUltimosNumeros + "/ultimoNumero22Resized.png"
  );
  scene.load.image(
    "ultimoNumero23",
    ROUTES.rutaRuletaUltimosNumeros + "/ultimoNumero23Resized.png"
  );
  scene.load.image(
    "ultimoNumero24",
    ROUTES.rutaRuletaUltimosNumeros + "/ultimoNumero24Resized.png"
  );
  scene.load.image(
    "ultimoNumero25",
    ROUTES.rutaRuletaUltimosNumeros + "/ultimoNumero25Resized.png"
  );
  scene.load.image(
    "ultimoNumero26",
    ROUTES.rutaRuletaUltimosNumeros + "/ultimoNumero26Resized.png"
  );
  scene.load.image(
    "ultimoNumero27",
    ROUTES.rutaRuletaUltimosNumeros + "/ultimoNumero27Resized.png"
  );
  scene.load.image(
    "ultimoNumero28",
    ROUTES.rutaRuletaUltimosNumeros + "/ultimoNumero28Resized.png"
  );
  scene.load.image(
    "ultimoNumero29",
    ROUTES.rutaRuletaUltimosNumeros + "/ultimoNumero29Resized.png"
  );
  scene.load.image(
    "ultimoNumero30",
    ROUTES.rutaRuletaUltimosNumeros + "/ultimoNumero30Resized.png"
  );
  scene.load.image(
    "ultimoNumero31",
    ROUTES.rutaRuletaUltimosNumeros + "/ultimoNumero31Resized.png"
  );
  scene.load.image(
    "ultimoNumero32",
    ROUTES.rutaRuletaUltimosNumeros + "/ultimoNumero32Resized.png"
  );
  scene.load.image(
    "ultimoNumero33",
    ROUTES.rutaRuletaUltimosNumeros + "/ultimoNumero33Resized.png"
  );
  scene.load.image(
    "ultimoNumero34",
    ROUTES.rutaRuletaUltimosNumeros + "/ultimoNumero34Resized.png"
  );
  scene.load.image(
    "ultimoNumero35",
    ROUTES.rutaRuletaUltimosNumeros + "/ultimoNumero35Resized.png"
  );
  scene.load.image(
    "ultimoNumero36",
    ROUTES.rutaRuletaUltimosNumeros + "/ultimoNumero36Resized.png"
  );  

}